import { render, staticRenderFns } from "./inspection-code.vue?vue&type=template&id=24a6e15a&scoped=true"
import script from "./inspection-code.vue?vue&type=script&lang=js"
export * from "./inspection-code.vue?vue&type=script&lang=js"
import style0 from "./inspection-code.vue?vue&type=style&index=0&id=24a6e15a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a6e15a",
  null
  
)

export default component.exports